import { colors } from "../../Styles";

export function Milestone({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M89.7,251.1h21.1V26.6c6.1-2,7.6-6.1,7.6-9.4s-1.3-10.8-18.1-10.8-18.1,8.3-18.1,10.8,1.4,7.4,7.6,9.4v224.5Z"/>
      <polygon points="240.7 31.1 115.4 31.1 115.4 124.6 240.6 124.6 210.9 77.3 240.7 31.1"/>
      <path d="M53.7,255.1c-6.1,0-11,4.9-11,11s4.9,11,11,11,11-4.9,11-11-4.9-11-11-11Z"/>
      <path d="M99.8,255.1c-6.1,0-11,4.9-11,11s4.9,11,11,11,11-4.9,11-11-4.9-11-11-11Z"/>
      <path d="M145.9,255.1c-6.1,0-11,4.9-11,11s4.9,11,11,11,11-4.9,11-11-4.9-11-11-11Z"/>
      <path d="M192,255.1c-6.1,0-11,4.9-11,11s4.9,11,11,11,11-4.9,11-11-4.9-11-11-11Z"/>
    </svg>
  );
}